export default "__VITE_ASSET__KPmV1K5o__"